
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke164aRequest, Sgke164aResponse, Sgke164aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke164aService {

  /**
   * コンストラクタ
   * @param {Sgke164aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke164aService
   */
  constructor(
    public service: Sgke164aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE164A_入金締め取消API呼び出し
   * @param {Sgke164aRequest} request 
   * @returns {Observable<Sgke164aResponse>}
   * @memberof UsedSgke164aService
   */
  public doSgke164a(request: Sgke164aRequest): Observable<Sgke164aResponse> {
    return this.service.sgke164aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE164A');
          return throwError(err.message);
        })
      );
  }

}
